/*
 * @Author: hujie striveyf@dingtalk.com
 * @Date: 2023-06-22 11:10:48
 * @LastEditors: hujie striveyf@dingtalk.com
 * @LastEditTime: 2023-06-23 08:58:55
 * @FilePath: \vysa_wifi_web\src\main.ts
 * @Description: 
 * 
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved. 
 */
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {
  Icon,
  Popup,
  Button,
  RadioGroup,
  Radio,
  Cell,
  CellGroup,
  Form,
  Field,
  NavBar,
  Toast,
  Tabs,
  Tab,
  TreeSelect,
  List,
} from 'vant';

import 'vant/lib/index.css';

const app = createApp(App)
app.use(Icon)
app.use(Button)
app.use(Popup)
app.use(Radio)
app.use(RadioGroup)
app.use(Cell)
app.use(CellGroup)
app.use(Form)
app.use(Field)
app.use(NavBar)
app.use(Toast);
app.use(Tabs);
app.use(Tab);
app.use(TreeSelect);
app.use(List);
app.use(store).use(router).mount('#app')
